import axios from "axios";

export const axiosInstance_user = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_USER,
});

console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL_USER);

axiosInstance_user.interceptors.request.use(
  function (config) {
    // const token = localStorage.getItem("token");
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // console.log("Request Headers:", config.headers);
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosInstance_user.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
